import { getCurrentSiteTakeover } from 'takeovers/utils/hooks/useCurrentSiteTakeover'
import { LUX_PLUS_MONTH_TAKEOVER_ID } from 'takeovers/luxPlusMonthTakeover/constants/luxPlusMonthTakeoverConstants'

/**
 * Site takeovers that waive the LuxPlus+ joining fee for all customers for their duration.
 * Add a takeover's id here to make it waive the fee
 */
const JOINING_FEE_WAIVED_TAKEOVER_IDS: Array<string> = [
  LUX_PLUS_MONTH_TAKEOVER_ID,
]

/**
 * Plain state selector — works both via useAppSelector (components) and direct call
 * with getState() (Redux thunks), so there's no separate hook/non-hook variant needed.
 * Generic entry point for any reason the joining fee should be force-waived, not tied
 * to takeovers specifically — the takeover check is just today's implementation.
 */
export function getLuxPlusWaiveJoiningFeeOverride(state: App.State): boolean {
  const currentTakeoverId = getCurrentSiteTakeover(state)?.id
  return !!currentTakeoverId && JOINING_FEE_WAIVED_TAKEOVER_IDS.includes(currentTakeoverId)
}
